import { useEffect, useState } from "react";
import {CourseEvent} from "../../models/CourseEvent";
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import {Calendar} from 'react-bootstrap-icons';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { RichTextDisplay } from '../widget/RichText';
import CourseEventEndpoint from "../../../api/endpoint/CourseEventEndpoint";
import { displayDateAsVtTime, displayDateTimeAsVtTime, displayMonthAsVtTime } from "../../utils/DateManagement";

const dateCardStyle = {
    width: "6em",
    height: "6.5em",
    display: "inline-block",
    color: "primary",
    borderRadius: '5px'
} as const;

const dateCardTextStyle = {
    position: "relative",
    right: "17%",
    top: "13%",
    fontSize: '1em',
    fontWeight: 'bold'
} as const;

const dateIconStyle = {
    position: "relative",
    left: "23%",
    zIndex: 0
} as const;

export const UpcomingCourses = () => {
    const [courses, setCourses] = useState<CourseEvent[] | undefined>(undefined);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        if(isInitialLoad){
            getCourses();
            setIsInitialLoad(false);
        }
    }, [isInitialLoad]);

    const getCourses = async () => {
        const result = await CourseEventEndpoint.GetUpcoming();
        const courseEventsResult: CourseEvent[] = result.data.map((row: any) => ({
            course_event_id: Number(row.course_event_id),
            course_id: Number(row.course_id),
            title: row.title,
            hours: row.hours,
            location: row.location,
            close_date: new Date(Date.parse(row.close_date)),
            start_date: new Date(Date.parse(row.start_date)),
            end_date: new Date(Date.parse(row.end_date)),
            open_date: new Date(Date.parse(row.open_date)),
            max_registrations: row.max_registrations,
            current_registrations: row.current_registrations,
            description: row.description,
            location_details: row.location_details,
        }));
        setCourses(courseEventsResult);
    };

    return (
        <>
            <h1 className="text-light">Upcoming Courses</h1>
            <hr className="border"/>
            {courses && courses.length !== 0 && courses.map((course:CourseEvent, i: number) => {
                return(
                    
                    <Card style={{margin:"1em 0"}} key={`course_${i}`}>
                        <Card.Body>
                            <Container fluid>
                                <Row>
                                    <Col md={2} style={{borderRight:"2px solid #e6e8e9"}}>
                                        <Row className="justify-content-evenly ">
                                            
                                            {/* First class date */}
                                            <div className="text-primary" style={dateCardStyle}>
                                                <div className="text-center" style={{fontVariant:"small-caps", fontWeight:"bold"}}>
                                                    {displayMonthAsVtTime(course.start_date)}
                                                </div>
                                            
                                                <div>
                                                    <Calendar size={"2.5em"} style={dateIconStyle}></Calendar>
                                                    <span style={dateCardTextStyle}>{displayDateAsVtTime(course.start_date)}</span>
                                                </div>
                                                <div className="text-center" style={{fontSize:"0.75em", fontVariant:"small-caps"}}>First<br/>Session</div>
                                            </div>

                                            {/* Last class date */}
                                            <div className="text-primary" style={dateCardStyle}>
                                                <div className="text-center" style={{fontVariant:"small-caps", fontWeight:"bold"}}>
                                                    {displayMonthAsVtTime(course.end_date)}
                                                </div>
                                                
                                                <div>
                                                    <Calendar size={"2.5em"} style={dateIconStyle}></Calendar>
                                                    <span style={dateCardTextStyle}>{displayDateAsVtTime(course.end_date)}</span>
                                                </div>
                                                <div className="text-center" style={{fontSize:"0.75em", fontVariant:"small-caps"}}>Last<br/>Session</div>
                                            </div>

                                            {/* Registration open date */}
                                            <div className="text-success" style={dateCardStyle}>
                                                <div className="text-center" style={{fontVariant:"small-caps", fontWeight:"bold"}}>
                                                    {displayMonthAsVtTime(course.open_date)}
                                                </div>
                                        
                                                <div>
                                                    <Calendar size={"2.5em"} style={dateIconStyle}></Calendar>
                                                    <span style={dateCardTextStyle}>{displayDateAsVtTime(course.open_date)}</span>
                                                </div>
                                                <div className="text-center" style={{fontSize:"0.75em", fontVariant:"small-caps"}}>Registration Opens</div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col md={10} style={{paddingLeft:"2em"}}>
                                        <Card.Title>{course.title}</Card.Title>
                                        <Card.Subtitle className="text-muted">
                                            <div className="d-flex justify-content-start pb-2">
                                                <div className="pe-3">{course.location}</div>
                                                <div className="pe-3">&bull;</div>
                                                <div className="pe-3">{course.hours} hours</div>
                                                <div className="pe-3">&bull;</div>
                                                <div className="pe-3">Registration opens {displayDateTimeAsVtTime(course.open_date)}</div>
                                            </div> 
                                        </Card.Subtitle>
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Course Description</Accordion.Header>
                                                <Accordion.Body className="readonly-description">
                                                    <RichTextDisplay value={course.description} />
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </Col>
                                </Row>
                                
                        </Container>
                        </Card.Body>
                    </Card>
                );
            })}
            {!courses || courses.length == 0 &&
                <div className="text-light">No upcoming courses.</div>
            }
        </>
    );
};